import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { updateCollectMDocSDoc } from "../Actions/MMPLDashboardAPI";
import { UploadMDoc, UploadSDoc } from "../Actions/CommonAPI"

class MMPLUpdateMDocSDoc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ihmPresenseYes: true,
            ihmPresenseNo: false,
            mdocfile: "",
            sdocfile: "",
            MDocFilename: "",
            SDocFilename: "",
            CollectMdocSdoc: {
                shipId: 0,
                purchaseOrderId: 0,
                poLineItemId: 1,
                ihmPresence: true,
                mdocAttachmentId: "",
                mdocAttachmentName: "",
                mdocAttachmentGuid: "",
                sdocAttachmentId: "",
                sdocAttachmentName: "",
                sdocAttachmentGuid: "",
                modifiedBy: ""
            }
        };
        this.onHandleInputChange = this.onHandleInputChange.bind(this);
        this.onHandleRadioInputChange = this.onHandleRadioInputChange.bind(this);
    }
    componentDidMount() {
        const { CollectMDocSDocDetails } = this.props;
        if (CollectMDocSDocDetails) {
            this.state.CollectMdocSdoc.shipId = CollectMDocSDocDetails.shipId;
            this.state.CollectMdocSdoc.purchaseOrderId = CollectMDocSDocDetails.purchaseOrderId;
            this.state.CollectMdocSdoc.poLineItemId = CollectMDocSDocDetails.poLineItemId;
            this.setState({});
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, MDocAttachment, SDocAttachment } = nextProps;
        if (MDocAttachment) {
            prevState.CollectMdocSdoc.mdocAttachmentName = MDocAttachment.FileName;
            prevState.CollectMdocSdoc.mdocAttachmentGuid = MDocAttachment.Guid;
            prevState.mdocfile = '';
        }
        if (SDocAttachment) {
            prevState.CollectMdocSdoc.sdocAttachmentName = SDocAttachment.FileName;
            prevState.CollectMdocSdoc.sdocAttachmentGuid = SDocAttachment.Guid;
            prevState.sdocfile = '';
        }
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "EditPOView", data: false });
        this.props.dispatch({ type: "ShowPODetail", data: false });
        this.props.dispatch({ type: "MMPLSidePanCollectDocs", data: false });
        this.props.history.goBack();
    };


    UpdateService() {
        const { dispatch } = this.props;
        dispatch(updateCollectMDocSDoc(this.state.CollectMdocSdoc));
        dispatch({ type: "MMPLSidePanCollectDocs", data: false });
    }

    onHandleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "MDoc") {
            this.state.MDocFilename = e.target.files[0].name;
            this.state.mdocfile = e.target.files[0];
            this.setState({});
            this.props.dispatch(UploadMDoc(e.target.files[0]));
        } else if (nodeName === "SDoc") {
            this.state.SDocFilename = e.target.files[0].name;
            this.state.sdocfile = e.target.files[0];
            this.setState({});
            this.props.dispatch(UploadSDoc(e.target.files[0]));
        }
    }

    onHandleRadioInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "ihmPresenseYes") {
            this.state.CollectMdocSdoc.ihmPresence = true;
            this.setState({
                ihmPresenseYes: true,
                ihmPresenseNo: false
            });
        } else if (nodeName === "ihmPresenseNo") {
            this.state.CollectMdocSdoc.ihmPresence = false;
            this.setState({
                ihmPresenseYes: false,
                ihmPresenseNo: true
            });
        }
    }

    ClearMDoc() {
        this.setState({
            mdocfile: "",
            MDocFilename: ""
        })
    }

    ClearSDoc() {
        this.setState({
            sdocfile: "",
            SDocFilename: ""
        })
    }

    render() {
        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}>
                                &larr; Return
                            </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            Update MD & SDoC
                                        </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">MD </label><br></br>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">Choose file<input type="file" id="files" name="MDoc" onChange={e => this.onHandleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="No file chosen" value={this.state.MDocFilename} />
                                                    {this.state.MDocFilename !== "" ?
                                                        <div class="input-group-append">
                                                            <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearMDoc()}></i>
                                                        </div>
                                                        : null}
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">SDoC </label><br></br>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">Choose file<input type="file" id="files" name="SDoc" onChange={e => this.onHandleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="No file chosen" value={this.state.SDocFilename} />
                                                    {this.state.SDocFilename !== "" ?
                                                        <div class="input-group-append">
                                                            <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearSDoc()}></i>
                                                        </div>
                                                        : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">IHM Presense</label><br></br>
                                                <div class="row">
                                                    <div className="col-sm-12 col-md-12">
                                                        <span className="mr-4">
                                                            <input type="radio" name="ihmPresenseYes" checked={this.state.ihmPresenseYes} onChange={e => this.onHandleRadioInputChange(e)} />
                                                            <span className="ml-1">Yes</span>
                                                        </span>
                                                        <span className="mr-4">
                                                            <input type="radio" name="ihmPresenseNo" checked={this.state.ihmPresenseNo} onChange={e => this.onHandleRadioInputChange(e)} />
                                                            <span className="ml-1">No</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className={"col-lg-12 mb-2 mt-2"}>
                                                <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                                    <button
                                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                        type="submit" onClick={() => this.UpdateService()}
                                                        disabled={!this.state.MDocFilename || !this.state.SDocFilename}>
                                                        Submit{" "}
                                                    </button>
                                                    <button
                                                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                        type="button">
                                                        Cancel{" "}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        MDocAttachment: state.MMPLDashboardReducer.MDocAttachment,
        SDocAttachment: state.MMPLDashboardReducer.SDocAttachment,
        CollectMDocSDocDetails: state.MMPLDashboardReducer.CollectMDocSDocDetails
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MMPLUpdateMDocSDoc)
);
